module.exports = __webpack_public_path__ + "images/made-with-bulma-e0eab74d48c6d753ef9bc506d665f376.png";